export default __webpack_public_path__ + "static/Taiwan-5e138b53ed4d4eb3b75e1c91e1caa3cb.png";